export const APP_VERSION = '3.45.0';

export type EnvironmentName = 'dev' | 'qa' | 'livet' | 'uat' |'prod';

export const API_GATEWAY_BASE_URLS: Record<EnvironmentName, string> = {
  dev: 'https://api-test.finap-usa.com',
  qa  :'https://api-qa.finap-usa.com',
  livet: 'http://172.188.207.123',
  uat: 'https://api-uat.finap-usa.com',
  prod:'https://api.finap-usa.com'
};
